import { effectiveRegistrationClosesAt } from './event-time';

export type EventRegistrationReason =
  'full' | 'closed' | 'started' | 'paid' | 'unavailable' | 'checked_in';

export type EventRegistrationEligibility =
  | Readonly<{ eligible: true; reason: null }>
  | Readonly<{ eligible: false; reason: Exclude<EventRegistrationReason, 'checked_in'> }>;

type RegistrationEligibilityEvent = Readonly<{
  attendee_count: number;
  capacity: number | null;
  ends_at: string | null;
  payment_methods: readonly string[];
  registration_closes_at: string | null;
  registration_price_thb: number;
  starts_at: string;
  status: string;
}>;

export function eventRegistrationEligibility(
  event: RegistrationEligibilityEvent,
  now: Date
): EventRegistrationEligibility {
  if (event.status !== 'published') return { eligible: false, reason: 'unavailable' };
  if (now >= new Date(event.starts_at)) return { eligible: false, reason: 'started' };
  if (now >= effectiveRegistrationClosesAt(event)) return { eligible: false, reason: 'closed' };
  if (event.registration_price_thb > 0 || event.payment_methods.length > 0) {
    return { eligible: false, reason: 'paid' };
  }
  if (event.capacity !== null && event.attendee_count >= event.capacity) {
    return { eligible: false, reason: 'full' };
  }
  return { eligible: true, reason: null };
}

export function eventRegistrationUnavailableCopy(reason: EventRegistrationReason): string {
  switch (reason) {
    case 'full':
      return 'This event is full.';
    case 'closed':
      return 'Registration is closed.';
    case 'started':
      return 'This event has started.';
    case 'paid':
      return 'Paid event registration is coming soon.';
    case 'checked_in':
      return 'Checked-in attendance cannot be cancelled.';
    default:
      return 'Registration is unavailable.';
  }
}
